import { CanActivateFn } from '@angular/router';

import { CompanyService } from '../services/company.service';

export const SportsbookGuard: CanActivateFn = () => {
  const screenConfig = CompanyService.currentScreenView?.sportsbook_screen;
  if (screenConfig && 'enable' in screenConfig) {
    return screenConfig?.enable;
  } else {
    return true;
  }
};
